import { AuditLogTable } from './components/audit-log-table';

/**
 * Wallet Audit Log Page
 * Central view for all admin wallet adjustments
 */
export function WalletAuditLogPage() {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl font-bold">Wallet Audit Log</h1>
        <p className="text-muted-foreground mt-1">
          Track all administrative wallet adjustments and modifications
        </p>
      </div>

      <AuditLogTable />
    </div>
  );
}
